import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'SIDEBAR_UPDATE',
    smsDelete : 'SIDEBAR_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        sidebar: [],
        mainToggle: null,
        submitSuccess: false,
        sidebarLoading: false,
        sidebarError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_SIDEBAR(state, sidebar) {
            state.sidebar = sidebar;
        },

        SET_MAIN_TOGGLE(state, toggle) {
            state.mainToggle = toggle;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        SIDEBAR_LOADING (state, loading) {
            state.sidebarLoading = loading;
        },

        SIDEBAR_ERROR (state, hasError) {
            state.sidebarError = hasError;
        }
    },

    actions: {
        async fetchSidebar ({ commit }) {
            commit('SIDEBAR_LOADING', true);
            commit('SIDEBAR_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.sidebar_list, config);
                let response = result.data
                commit('SET_SIDEBAR', response.data);

            } catch(error) {
                commit('SIDEBAR_ERROR', true);
            } finally {
                commit('SIDEBAR_LOADING', false);
            }
        },

        async toggleSidebar ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.get(V1API.update_sidebar_toggle + payload, config).then(result=>{
                let data = result.data
                return data
            });

            commit('SUBMIT_SUCCESS', true);
            dispatch ('fetchSidebar')
            return response
        },

        async fetchMainToggle ({ commit }) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let result = await axios.get(V1API.main_toggle_value, config);
            let response = result.data.data
            commit('SET_MAIN_TOGGLE', response.sidebar);
        },

        async toggleMainSidebar ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.get(V1API.update_main_toggle, config).then(result=>{
                let data = result.data
                return data
            });

            commit('SUBMIT_SUCCESS', true);
            dispatch ('fetchMainToggle')
            return response
        }
    },

    getters: {}
}
